import { Component, Input, OnInit } from "@angular/core";

import { Fiat } from "@models";

import { FiatService } from "@main-services/currency/fiat.service";
import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { CurrencyTransactionListItemComponent } from "../../currency-transaction-list-item.component";
import { TradableWallet } from "@models/interfaces/tradable_wallet";
import { FiatTransaction } from "@models/transaction";
import { ModalService } from "@core-services/modal.service";
import { MasterdataService } from "@core-services/masterdata.service";
import { WalletsBalancesFacadeService } from "@modules/+new/core/wallets-balances/domain/+state/wallets-balances.facade.service";
import { WalletBalance } from "@modules/+new/core/wallets-balances/domain/entities/wallet-balance.model";
import { EMPTY, Observable } from "rxjs";
import { isEarnOnFiatTagComparisonHelper } from "@modules/transaction/transaction.utils";

@Component({
	selector: "fiat-transaction-list-item",
	templateUrl: "./fiat-transaction-list-item.component.html",
	styleUrls: ["./fiat-transaction-list-item.component.scss"],
	standalone: false
})
export class FiatTransactionListItemComponent extends CurrencyTransactionListItemComponent implements OnInit {
	@Input() public focusable: boolean = false;
	@Input() public transaction: FiatTransaction = null;
	@Input() public isWidget: boolean = false;
	public balance: Observable<WalletBalance> = EMPTY;
	public isEarnOnFiat = false;

	public constructor(
		protected masterdataService: MasterdataService,
		protected tradableWalletListService: TradableWalletListService,
		protected fiatWalletService: FiatWalletService,
		protected fiatService: FiatService,
		protected tradableListService: TradableListService,
		protected modalService: ModalService,
		protected balancesFacade: WalletsBalancesFacadeService
	) {
		super(masterdataService, tradableWalletListService, fiatService, tradableListService, modalService);
	}

	public get fiat(): Fiat {
		return this.fiatService.getItemById(this.transaction.getFiatId());
	}

	public get wallet(): TradableWallet {
		return this.tradableWalletListService.getItemById(this.transaction.getTrade().getWalletId(), true);
	}

	public ngOnInit(): void {
		// check for tag name (MMF)
		const trade = this.transaction?.getTrade();
		this.isEarnOnFiat = isEarnOnFiatTagComparisonHelper(trade?.getTags());

		this.balance = this.balancesFacade.getFiatWalletBalance$(this.transaction.getFiatWalletId());
	}
}
